import { Text } from '@mantine/core';
import { DataTableColumn } from 'mantine-datatable';
import React from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SimpleTable } from 'src/common/components/table/SimpleTable';
import { formatDate } from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import { MeetingNoteDraftsModal } from './MeetingNoteDraftsModal';
import { AdminMeetingNote } from './types';

type MeetingNotesTableProps = {
  company: Company;
};

export function MeetingNotesTable({ company }: MeetingNotesTableProps) {
  const [selectedId, setSelectedId] = React.useState<string | null>(null);

  const columns: DataTableColumn<AdminMeetingNote>[] = [
    {
      accessor: 'id',
      title: 'ID',
      render: (record: AdminMeetingNote) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.id}
        </Text>
      ),
    },
    {
      accessor: 'clientId',
      title: 'Client ID',
      render: (record: AdminMeetingNote) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.clientId}
        </Text>
      ),
    },
    {
      accessor: 'fileName',
      title: 'File name',
      render: (record: AdminMeetingNote) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.fileName ?? '-'}
        </Text>
      ),
    },
    {
      accessor: 'templateId',
      title: 'Template ID',
      render: (record: AdminMeetingNote) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.templateId ?? '-'}
        </Text>
      ),
    },
    {
      accessor: 'createdAt',
      title: 'Created at',
      width: 170,
      render: (record: AdminMeetingNote) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {formatDate(record.createdAt)}
        </Text>
      ),
    },
    {
      accessor: 'markdownPreview',
      title: 'Preview',
      render: (record: AdminMeetingNote) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10" lineClamp={2}>
          {record.markdownPreview ?? '-'}
        </Text>
      ),
    },
  ];

  return (
    <>
      <MeetingNoteDraftsModal
        meetingNoteId={selectedId}
        companyId={company.id}
        onClose={() => setSelectedId(null)}
      />

      <SimpleTable<AdminMeetingNote>
        mode="server"
        resource={`admin/companies/${company.id}/meeting-notes`}
        title="Meeting notes"
        columns={columns}
        onRowClick={record => setSelectedId(record.id)}
        showCount
      />
    </>
  );
}
